module.exports = __webpack_public_path__ + "static/simplicity_panel-3303bcb4b2f9efc1de800405a25b6403.png";